module.exports = __webpack_public_path__ + "0bd536c4cfaf727ef6cbf503037319c4.jpg";